
const digest = 'a6816c61fc6d4adb75122e3128d33047ce7c270ec56538ac38d126098eaff921';
const classes = {"wrapper":"_wrapper_blv2a_1","border":"_border_blv2a_4","content":"_content_blv2a_13","header":"_header_blv2a_18","openEntryName":"_openEntryName_blv2a_25","itemInfo":"_itemInfo_blv2a_36","version":"_version_blv2a_41","controls":"_controls_blv2a_53"};
const css = `._wrapper_blv2a_1 {
  background: #fff;
}
._wrapper_blv2a_1 ._border_blv2a_4 {
  display: flex;
  flex-direction: row;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_blv2a_1 ._border_blv2a_4:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_blv2a_1 ._border_blv2a_4 ._content_blv2a_13 {
  flex: 1;
  display: flex;
  flex-direction: column;
}
._wrapper_blv2a_1 ._border_blv2a_4 ._content_blv2a_13 ._header_blv2a_18 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 12px;
  padding: 12px 0 0 0;
}
._wrapper_blv2a_1 ._border_blv2a_4 ._content_blv2a_13 ._header_blv2a_18 ._openEntryName_blv2a_25 {
  font-size: 16px;
  font-weight: 500;
  gap: 15px;
  display: flex;
  align-items: center;
}
._wrapper_blv2a_1 ._border_blv2a_4 ._content_blv2a_13 ._header_blv2a_18 ._openEntryName_blv2a_25 span {
  font-size: 12px;
  color: #ccc;
}
._wrapper_blv2a_1 ._border_blv2a_4 ._content_blv2a_13 ._itemInfo_blv2a_36 {
  display: flex;
  flex-direction: column;
  margin: 12px;
}
._wrapper_blv2a_1 ._border_blv2a_4 ._version_blv2a_41 {
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #eaedf3;
  gap: 15px;
  flex-direction: column;
  min-width: 110px;
  font-size: 14px;
  color: #3e3f42;
}
._wrapper_blv2a_1 ._border_blv2a_4 ._controls_blv2a_53 {
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #eaedf3;
  gap: 15px;
  flex-direction: column;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  